import React, { useEffect } from 'react';
import { Flex, Heading, Image, Text } from '@chakra-ui/react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuthContext } from '../AuthProvider';

const Login = () => {
  const { user } = useAuthContext();
  const navigate = useNavigate();
  const { search } = useLocation();

  useEffect(() => {
    const callback = decodeURIComponent(
      search.split('?callback=').pop() as string
    );
    if (user) {
      navigate(callback, { replace: true });
    }
  }, [user, navigate, search]);
  return (
    <Flex
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="100vh"
    >
      <Flex justifyContent="end" width="100%" px="3rem">
        <Image src="/images/logo.png" alt="logo" width="150px" />
      </Flex>
      <Flex
        flexDirection="column"
        alignItems="start"
        width="100%"
        pl="3rem"
        pb="5rem"
      >
        <Heading as="h2" size="xl" py="3rem">
          Billboard
        </Heading>
        <Text fontSize="2xl">내 주변에</Text>
        <Text fontSize="2xl" fontWeight="bold">
          보드게임 모임
        </Text>
      </Flex>
      <Link
        to={`https://kauth.kakao.com/oauth/authorize?client_id=${
          process.env.REACT_APP_KAKAO_CLIENT_ID
        }&redirect_uri=${encodeURIComponent(
          process.env.REACT_APP_REDIRECT_URI || ''
        )}&response_type=code`}
      >
        <Image
          width="320px"
          src="/images/kakao_login_large_wide.png"
          alt="/images/kakao_login_large_wide.png"
        />
      </Link>
    </Flex>
  );
};

export default Login;
